import supabase from '../supabaseClient';

const ESTADOS_ACTIVOS = ['pendiente', 'aceptado', 'en_proceso'];

// Reservado de un lote = suma de pedidos_lineas de pedidos en estado activo. Siempre derivado, nunca almacenado.
export const cargarReservas = async (almacen_id, excluirPedidoId = null) => {
  if (!almacen_id) return new Map();
  const { data: pedidosActivos } = await supabase
    .from('pedidos')
    .select('id')
    .eq('almacen_id', almacen_id)
    .in('estado', ESTADOS_ACTIVOS);

  let ids = (pedidosActivos || []).map(p => p.id);
  if (excluirPedidoId) ids = ids.filter(id => id !== excluirPedidoId);
  if (ids.length === 0) return new Map();

  const { data: lineas } = await supabase
    .from('pedidos_lineas')
    .select('referencia, fecha_caducidad, cantidad_cajas, cantidad_palets')
    .in('pedido_id', ids);

  const mapa = new Map();
  for (const l of (lineas || [])) {
    const key = `${l.referencia}|${l.fecha_caducidad || "null"}`;
    if (!mapa.has(key)) mapa.set(key, { cajas: 0, palets: 0 });
    const e = mapa.get(key);
    e.cajas += l.cantidad_cajas || 0;
    e.palets += l.cantidad_palets || 0;
  }
  return mapa;
};

export const reservaDeLote = (mapaReservas, referencia, fecha_caducidad) =>
  mapaReservas.get(`${referencia}|${fecha_caducidad || "null"}`) || { cajas: 0, palets: 0 };
